export const AUTH_SUCCESS_REDIRECT_DELAY_MS = 550;

export const scheduleAuthSuccessRedirect = (
  redirectUrl: string,
  delayMs = AUTH_SUCCESS_REDIRECT_DELAY_MS,
): number =>
  window.setTimeout(() => {
    window.location.href = redirectUrl;
  }, delayMs);
